
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"21","viewBox":"0 0 20 21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10 .063c-3.08 0-5.872 1.445-7.7 3.636l-.749-.738a.544.544 0 00-.597-.14.54.54 0 00-.387.468L.005 7.156c-.063.476.485.748.668.656l3.865-.55a.555.555 0 00.469-.387.59.59 0 00-.141-.61l-.89-.89A7.67 7.67 0 0110 2.445c4.182 0 7.641 3.41 7.653 7.594v.024c0 .148-.005.297-.014.445-.023.37.3.67.67.617l1.18-.173a.586.586 0 00.5-.56c.004-.11.006-.22.006-.33 0-5.486-4.487-10-9.995-10zM19.327 12.195l-3.866.55a.555.555 0 00-.468.387.591.591 0 00.14.61l.938.937a7.652 7.652 0 01-6.072 3c-4.193 0-7.652-3.422-7.652-7.617.004-.076-.01-.24.016-.552a.587.587 0 00-.666-.63l-1.18.167a.586.586 0 00-.503.553c-.015.327-.008.59-.01.708.129 5.379 4.584 9.754 9.995 9.754 3.116 0 5.931-1.469 7.758-3.707l.691.691c.154.171.41.216.598.14a.541.541 0 00.386-.468l.562-3.867c.049-.363-.286-.72-.667-.656z","fill":"#E2E8F0"}})])
          )
        }
      }
    